module.exports = __webpack_public_path__ + "assets/user.54a04098.svg";